/** @jsx jsx */
/** @jsxFrag */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';
import HtmlParser from 'react-html-parser';
import { PressArticle } from 'types/PressReleasesData';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ArticleDetailProps extends React.HTMLAttributes<HTMLDivElement> {
  article: PressArticle;
}

const ArticleDetail = React.forwardRef<HTMLDivElement, ArticleDetailProps>(({ article }, ref) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <div ref={ref} css={{ alignItems: 'flex-start', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <h1 css={{ ...theme.typography.h1, color: theme.palette.primary.main, marginBottom: theme.spacing(5) }}>
            {article.title}
          </h1>
          <div>{HtmlParser(article.text)}</div>
        </div>
      )}
    </ClassNames>
  );
});

export default ArticleDetail;
